// Point d'entrée du front.
//
// Les polices sont importées comme dépendances npm, jamais par un
// <link> vers Google : pas de requête vers un tiers (RGPD), et surtout
// pas d'erreur d'AGC où IBM Plex était déclarée dans le CSS et jamais
// chargée — l'application y a tourné sept semaines sur system-ui sans
// que personne le remarque.

import '@fontsource/barlow/300.css';
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import './styles/tokens.css';
import './styles/base.css';
import './ui/ui.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import Barriere from './ui/Barriere.jsx';
import App from './App.jsx';
import { SessionProvider } from './lib/session.jsx';
import { ToastProvider } from './ui/Toast.jsx';

// ── UN ROUTEUR DE DONNÉES — 6 octobre 2026 ──
//
// `<BrowserRouter>` n'offre pas `useBlocker`, et rien ne gardait donc la
// navigation interne : Philippe passait du devis 062 à un autre par le
// menu et perdait tout. Une seule route `*` rend l'application telle
// qu'elle était — ses `<Routes>` deviennent des routes descendantes et ne
// changent pas — mais `useBlocker` existe désormais (`useEnregistrement`).
function Racine() {
  return (
    <ToastProvider>
      <SessionProvider>
        {/* La barrière GLOBALE. Sans elle, un import oublié dans un
            bloc efface l'application entière : #root à zéro caractère,
            aucun message, rien à cliquer — l'utilisateur n'a même pas
            de quoi décrire ce qu'il voit. */}
        <Barriere>
          <App />
        </Barriere>
      </SessionProvider>
    </ToastProvider>
  );
}

const routeur = createBrowserRouter([{ path: '*', element: <Racine /> }]);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <RouterProvider router={routeur} />
  </StrictMode>,
);
